import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Help from "@/components/Help";
import Dealers from "@/components/Dealer/Dealers";
import DealerCreate from "@/components/Dealer/DealerCreate";
import Dealer from "@/components/Dealer/Dealer";
import Users from "@/components/User/Users";
import UserCreate from "@/components/User/UserCreate";
import UserEdit from "@/components/User/UserEdit";
import Modules from "@/components/Module/Modules";
import ModuleCreate from "@/components/Module/ModuleCreate";
import ModuleEdit from "@/components/Module/ModuleEdit";
import OurLegalEntities from "@/components/OurLegalEntity/OurLegalEntities";
import OurLegalEntityCreate from "@/components/OurLegalEntity/OurLegalEntityCreate";
import OurLegalEntityEdit from "@/components/OurLegalEntity/OurLegalEntityEdit";
import Masters from "@/components/Master/Masters";
import MasterCreate from "@/components/Master/MasterCreate";
import Master from "@/components/Master/Master";
import MasterOrder from "@/components/Master/MasterOrder";
import Objects from "@/components/Object/Objects";
import ObjectCreate from "@/components/Object/ObjectCreate";
import Object from "@/components/Object/Object";
import Licenses from "@/components/License/Licenses";
import LicensesDelete from "@/components/License/LicensesDelete";
import LicenseEdit from "@/components/License/LicenseEdit";
import Logins from "@/components/Reports/Logins";
import LoginErrors from "@/components/Reports/LoginErrors";
import EndingMasters from "@/components/Reports/EndingMasters";
import EndingLicenses from "@/components/Reports/EndingLicenses";
import UserEmails from "@/components/Reports/UserEmails";
import News from "../components/News/News.vue";
import New from "../components/News/New.vue";
import InflowStat from "../components/Reports/InflowStat.vue";
import OutflowStat from "../components/Reports/OutflowStat.vue";
import ActiveStat from "../components/Reports/ActiveStat.vue";

Vue.use(Router);

const routes = [
    {
        path: '/login',
        name: 'Login',
        redirect: { name: 'Home' }
    },
    {
        path: '',
        name: 'Home',
        // meta: {
        //     title: 'Система лицензирования',
        // },
        component: Home
    },
    {
        path: '/help',
        name: 'Help',
        meta: {
            title: 'Помощь',
        },
        component: Help
    },
    {
        path: '/dealers',
        name: 'Dealers',
        meta: {
            title: 'Дилеры',
        },
        component: Dealers
    },
    {
        path: '/dealers/add',
        name: 'DealerCreate',
        meta: {
            title: 'Добавление Дилера',
        },
        component: DealerCreate
    },
    {
        path: '/dealers/:dealerId/',
        props: true,
        name: 'Dealer',
        meta: {
            title: 'Дилер',
        },
        component: Dealer
    },
    {
        path: '/users',
        name: 'Users',
        meta: {
            title: 'Пользователи',
        },
        component: Users
    },
    {
        path: '/users/add',
        name: 'UserCreate',
        meta: {
            title: 'Добавление Пользователя',
        },
        component: UserCreate
    },
    {
        path: '/users/:userId',
        props: true,
        name: 'UserEdit',
        meta: {
            title: 'Редактирование Пользователя',
        },
        component: UserEdit
    },
    {
        path: '/modules',
        name: 'Modules',
        meta: {
            title: 'Модули ПО',
        },
        component: Modules
    },
    {
        path: '/modules/add',
        name: 'ModuleCreate',
        meta: {
            title: 'Добавление Модуля ПО',
        },
        component: ModuleCreate
    },
    {
        path: '/modules/:moduleId',
        props: true,
        name: 'ModuleEdit',
        meta: {
            title: 'Редактирование Модуля ПО',
        },
        component: ModuleEdit
    },
    {
        path: '/our_legal_entities',
        name: 'OurLegalEntities',
        meta: {
            title: 'Наши ЮЛ'
        },
        component: OurLegalEntities
    },
    {
        path: '/our_legal_entities/add',
        name: 'OurLegalEntityCreate',
        meta: {
            title: 'Добавление Нашего ЮЛ'
        },
        component: OurLegalEntityCreate
    },
    {
        path: '/our_legal_entities/:ourLeId',
        props: true,
        name: 'OurLegalEntityEdit',
        meta: {
            title: 'Редактирование Нашего ЮЛ'
        },
        component: OurLegalEntityEdit
    },
    {
        path: '/masters',
        name: 'Masters',
        meta: {
            title: 'Мастер-лицензии',
        },
        component: Masters
    },
    {
        path: '/masters/add',
        name: 'MasterCreate',
        meta: {
            title: 'Добавление Мастер-лицензии',
        },
        component: MasterCreate
    },
    {
        path: '/masters/:masterId',
        props: true,
        name: 'Master',
        meta: {
            title: 'Мастер-лицензия',
        },
        component: Master
    },
    {
        path: '/master_order',
        name: 'MasterOrder',
        meta: {
            title: 'Заказ Мастер-лицензии'
        },
        component: MasterOrder
    },
    {
        path: '/objects',
        name: 'Objects',
        meta: {
            title: 'Объекты',
        },
        component: Objects
    },
    {
        path: '/objects/add',
        name: 'ObjectCreate',
        meta: {
            title: 'Добавление Объекта',
        },
        component: ObjectCreate
    },
    {
        path: '/objects/:objectId',
        props: true,
        name: 'Object',
        meta: {
            title: 'Объект',
        },
        component: Object
    },
    {
        path: '/licenses',
        name: 'Licenses',
        meta: {
            title: 'Лицензии',
        },
        component: Licenses
    },
    {
        path: '/licenses/delete',
        name: 'LicensesDelete',
        meta: {
            title: 'Удаление лицензий',
        },
        component: LicensesDelete
    },
    {
        path: '/licenses/:licenseId',
        props: true,
        name: 'LicenseEdit',
        meta: {
            title: 'Редактирование Лицензии',
        },
        component: LicenseEdit
    },
    {
        path: '/reports/users/logins',
        name: 'Logins',
        meta: {
            title: 'История Входов/Выходов',
        },
        component: Logins
    },
    {
        path: '/reports/users/errors',
        name: 'LoginErrors',
        meta: {
            title: 'Неудачные попытки войти',
        },
        component: LoginErrors
    },
    {
        path: '/reports/users/emails',
        name: 'UserEmails',
        meta: {
            title: 'Адреса почт пользователей',
        },
        component: UserEmails
    },
    {
        path: '/reports/masters',
        name: 'EndingMasters',
        meta: {
            title: 'Окончание Мастер-лицензий',
        },
        component: EndingMasters
    },
    {
        path: '/reports/stat/inflow',
        name: 'InflowStat',
        meta: {
            title: 'Приток лицензий',
        },
        component: InflowStat
    },
    {
        path: '/reports/stat/outflow',
        name: 'OutflowStat',
        meta: {
            title: 'Отток лицензий',
        },
        component: OutflowStat
    },
    {
        path: '/reports/stat/active',
        name: 'ActiveStat',
        meta: {
            title: 'Действующие лицензии',
        },
        component: ActiveStat
    },
    {
        path: '/reports/licenses',
        name: 'EndingLicenses',
        meta: {
            title: 'Окончание Лицензий',
        },
        component: EndingLicenses
    },
    {
        path: '/news',
        name: 'News',
        meta: {
            title: 'Новости',
        },
        component: News
    },
    {
        path: '/news/:id',
        name: 'New',
        meta: {
            title: 'Новость',
        },
        component: New
    },
]

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
